import React from 'react';
import { View, StyleSheet } from 'react-native';

import { Text, RadioGroup, RadioItem } from '../uiold';
import {
  AccessLevel,
  AccountPermissionKeys,
  ACCESS_LEVELS,
  AccessLevelList,
  DEFAULT_USER_PERMISSIONS,
} from '../../support/shared/constants/UserConstants';

type FeatureKey = keyof typeof DEFAULT_USER_PERMISSIONS;
type Descriptor = { description: string };

const FeatureList: Record<FeatureKey, Descriptor> = {
  users: { description: t('User Management') },
  vendors: { description: t('Vendor Management') },
  billing: { description: t('Billing') },
  metrics: { description: t('Data Collection') },
  attendance: { description: t('Attendance') },
  formBuilder: { description: t('Signup Form Builder') },
  marketsAndPricing: { description: t('Markets and Pricing') },
  marketSales: { description: t('Market Sales') },
  marketPages: { description: t('Market Pages') },
  vendorPlacement: { description: t('Vendor Placement and Maps') },
  settings: { description: t('Account Settings') },
};

export function PermissionSelectRadio(props: {
  permissionType: AccountPermissionKeys;
  permissionAction: AccessLevel;
  onChange: (value: unknown) => void;
  label?: string;
}) {
  let { permissionAction, permissionType, onChange, label } = props;
  return (
    <View style={styles.permissionGroup}>
      <View style={styles.labelDiv}>
        <Text style={styles.labelText}>
          {FeatureList[permissionType].description}
        </Text>
        {label && <Text style={styles.captionText}>{label}</Text>}
      </View>
      <RadioGroup
        selectedValue={permissionAction}
        alignHorizontal
        onChange={(value) => {
          onChange(value);
        }}
      >
        {ACCESS_LEVELS.map((action) => {
          return (
            <RadioItem
              key={`${permissionType}-${action}`}
              value={action}
              title={AccessLevelList[action].description}
            />
          );
        })}
      </RadioGroup>
    </View>
  );
}

let styles = StyleSheet.create({
  labelText: {
    fontWeight: '400',
    fontSize: 16,
  },
  labelDiv: {
    marginBottom: 2,
  },
  captionText: {
    color: 'grey',
    fontWeight: 'normal',
    fontStyle: 'italic',
  },
  permissionGroup: {
    marginVertical: 8,
    marginRight: 36,
  },
});
